import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useGetCurrentSession } from '@api/orval/apiHooks'
import { setAppTimezone } from '@lib/dayjs'
import { setSession } from '@store/modules/session/slice'

/*
  This hook is used to mirror the session data to the Redux store

  Example:
  const { session, isSuccess, isError, ...rest } = useGetCurrentSessionMirrorToRedux()
*/
export const useGetCurrentSessionMirrorToRedux = () => {
  const {
    data: session,
    isSuccess,
    isError,
    ...rest
  } = useGetCurrentSession({
    query: {
      gcTime: 15 * 60 * 1000, // 15 min (cache time)
    },
  })
  const dispatch = useDispatch()

  useEffect(() => {
    if (isSuccess) {
      setAppTimezone(session?.timezone)
      dispatch(setSession(session))
    } else {
      dispatch(setSession(null))
    }
  }, [isSuccess, session, dispatch])

  return { session, isSuccess, isError, ...rest }
}
